import api from '@services/api'

export const login = (email, password, errorCallback) => {
    return (dispatch, getState) => {
        api.login(email, password).subscribe(
            (res) => {
                console.log('login res', res)

                dispatch(setUser(res.data))
                dispatch(getCurrentUser())
            },
            (error) => {
                console.log('login error', error)
                errorCallback(error)
                Promise.resolve()
            }
        )
    }
}

export const logout = (callback) => {
    return (dispatch, getState) => {
        api.logout().subscribe(
            (res) => {
                console.log('logout', res)
                localStorage.setItem('@login-cred-key', null)
                dispatch(setUser(null))
                callback()
            },
            (error) => {
                console.log('logout error', error)
                Promise.resolve()
            }
        )
    }
}

export const getCurrentUser = (callback) => {
    return (dispatch, getState) => {
        api.getCurrentUser().subscribe(
            (res) => {
                console.log('get current user res', res)

                dispatch(setUser(res.data))
                if (callback) {
                    callback()
                }
            },
            (error) => {
                console.log('get current user error', error)
                Promise.resolve()
            }
        )
    }
}

export const getAllUsers = (page, pageSize, orderBy, search, filters) => {
    return (dispatch, getState) => {
        api.getAllUsers(page, pageSize, orderBy, search, filters).subscribe(
            (res) => {
                // console.log('get all users res', res)

                dispatch(setUsers(res.data))
            },
            (error) => {
                console.log('get all users error', error)
                Promise.resolve()
            }
        )
    }
}

export const setUser = (user) => ({
    type: 'SET_USER',
    user,
})

export const setUsers = (users) => ({
    type: 'SET_USERS',
    users,
})
